import React from 'react';
import get from 'lodash/get';
import LegacyTextRenderer from './LegacyTextRenderer';
var ExcerptRenderer = React.forwardRef(function (_a, ref) {
    var textContent = _a.textContent, className = _a.className, htmlExcerptLegacy = _a.htmlExcerptLegacy, isPollWithHtmlExcerpt = _a.isPollWithHtmlExcerpt, legacyTheme = _a.legacyTheme, disableStylesForLegacy = _a.disableStylesForLegacy, _b = _a.emptyPlaceHolder, emptyPlaceHolder = _b === void 0 ? '' : _b;
    if (!textContent) {
        return null;
    }
    var type = get(textContent, 'html.type');
    // not using the default value param because it should fall back for empty string, too
    var excerpt = get(textContent, 'excerpt') || emptyPlaceHolder;
    if (htmlExcerptLegacy && type === 'writer') {
        return (React.createElement(LegacyTextRenderer, { className: className, html: excerpt, theme: legacyTheme, disableStyles: disableStylesForLegacy, ref: ref }));
    }
    if (isPollWithHtmlExcerpt &&
        type === 'draft' &&
        excerpt.trim().length > 0) {
        return (React.createElement("div", { className: className, dangerouslySetInnerHTML: { __html: excerpt }, ref: ref }));
    }
    return (React.createElement("div", { className: className, ref: ref }, excerpt));
});
ExcerptRenderer.displayName = 'ExcerptRenderer';
export default ExcerptRenderer;
//# sourceMappingURL=ExcerptRenderer.js.map